import React from "react";
import {inject, observer} from "mobx-react";
import Button from "reactstrap/lib/Button";
import Swal from "sweetalert2";
import moment from "moment";
import {Link} from "react-router-dom";
import getRoutes from "../../../components/Akitatek/getRoutes";


// Libellés du journal : type de mouvement et motif
const TYPES = {
    SELL: "Vente", BUY: "Achat", INVENTAIRE: "Inventaire", ADD_MANUALLY: "Entrée", REMOVE_MANUALLY: "Sortie",
    CREATE: "Création", REMOVE: "Sortie",
};
const MOTIFS = {
    VENTE: "facturée", ACHAT: "commande reçue", INVENTAIRE: "comptage", CORRECTION: "correction", ENTREE: "à la main",
    CASSE: "casse", PERTE: "perte", RETOUR_FOURNISSEUR: "retour fournisseur", USAGE_INTERNE: "usage interne", AUTRE: "autre",
};
// Seuls les mouvements saisis dans le stock se corrigent ici ; une vente ou un achat se corrige sur son document
const CORRIGEABLES = ["ADD_MANUALLY", "REMOVE_MANUALLY", "INVENTAIRE", "CREATE"];

const TableMouvRow = inject("rootStore") (observer( class TableMouvRow extends React.Component {

    item;

    get injected() {
        return this.props;
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            disabled: true,
            lot: this.injected.item.lot ?? "",
            commande: this.injected.item.commande ?? "",
            commande_produit: this.injected.item.commande_produit ?? "",
            facture: this.injected.item.facture ?? "",
            idProduct: this.injected.item.product?.id ?? "",
            name: this.injected.item.product?.nom ?? "",
            type: this.injected.item.type,
            quantite: this.injected.item.quantite ?? 0,
            created_at: this.injected.item.created_at ?? "",
            updated_at: this.injected.item.updated_at ?? "",
            id: this.injected.item.id ?? "",
            reason: this.injected.item.reason ?? "",
            motif: this.injected.item.motif ?? "",
            user: this.injected.item.user ?? "",
            corrige: !!this.injected.item.correction,
            correctionDe: this.injected.item.corrige_mouvement_id ?? "",
            };
    }

    onCorriger() {
        Swal.fire({
            title: "Corriger le mouvement #" + this.state.id + " ?",
            text: "Il reste dans le journal ; un mouvement inverse de " + (-1 * this.state.quantite) + " l'annule.",
            input: 'text',
            inputPlaceholder: "Pourquoi ? (facultatif)",
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Corriger',
            cancelButtonText: 'Retour',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const status = await this.injected.rootStore.stockStore.mouvStore.corrigerMouv(this.state.id, result.value)
                if (status === "success" && this.injected.onUpdate) {
                    this.injected.onUpdate()
                }
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (this.injected.item !== prevProps.item ) {
            this.setState({
                idProduct: this.injected.item.product?.id ?? "",
                name: this.injected.item.product?.nom ?? "",
                type: this.injected.item.type,
                quantite: this.injected.item.quantite ?? 0,
                created_at: this.injected.item.created_at ?? "",
                updated_at: this.injected.item.updated_at ?? "",
                id: this.injected.item.id ?? "",
                lot: this.injected.item.lot ?? "",
                commande_produit: this.injected.item.commande_produit ?? "",
                facture: this.injected.item.facture ?? "",
                reason: this.injected.item.reason ?? "",
                motif: this.injected.item.motif ?? "",
                user: this.injected.item.user ?? "",
                corrige: !!this.injected.item.correction,
                correctionDe: this.injected.item.corrige_mouvement_id ?? "",
            })
        }
    }

    render() {
        return (
            <>
                <tr style={{ textAlign: "center"}}>
                    <th scope="row">
                        <span className="mb-0 text-sm">
                            { this.state.lot ? (
                                this.state.lot?.pid
                            ): ("Pas de lot associé")
                            }
                        </span>
                    </th>

                        <th scope="row">
                        <span className="mb-0 text-sm">
                           { this.state.facture ? (

                               <Link to={{
                                   pathname: getRoutes("Gérer une facture", this.state.facture.id),
                                   aboutProps: {
                                       isCommandeValid: true,
                                       invoice: this.state.facture
                                   }
                               }}>
                                   #{this.state.facture?.id}  - {this.state.facture?.intitule}
                               </Link>
                           ): ("Pas de facture associée")
                           }
                        </span>
                        </th>

                        <th scope="row">
                            <span className="mb-0 text-sm">
                                { this.state.commande_produit ? (
                                    <Link to={{
                                        pathname: "/command/update/" + this.state.commande_produit.commande.id,
                                        aboutProps: {
                                            isCommandeValid: true,
                                            commande: this.state.commande_produit.commande
                                        }
                                    }}>
                                        #{this.state.commande_produit.commande.id} - {this.state.commande_produit.commande.title}
                                    </Link>
                                ): ("Pas de commande magasin associée")
                                }
                            </span>
                        </th>

                    <th scope="row">
                            <span className="mb-0 text-sm">
                                { this.state.commande ? (
                                    <Link to={{
                                        pathname: "/commandes/modifier/" + this.state.commande.id,
                                        aboutProps: {
                                            commande: this.state.commande
                                        }
                                    }}>
                                        #{this.state.commande.id}
                                    </Link>
                                ): ("Pas de commande client associée")
                                }
                            </span>
                    </th>

                    <td>
                        <strong>{TYPES[this.state.type] ?? this.state.type}</strong>
                        {this.state.motif && (<> · {MOTIFS[this.state.motif] ?? this.state.motif}</>)}
                        {this.state.correctionDe && (<> du #{this.state.correctionDe}</>)}
                        {this.state.reason && (<div className="text-muted text-sm">{this.state.reason}</div>)}
                        {this.state.corrige && (<div className="text-muted text-sm">Corrigé</div>)}
                    </td>

                    <td className="th-price td-start" style={{ textAlign: "center"}}>
                        {this.state.quantite}
                    </td>

                    <td  style={{ textAlign: "center"}}>
                        <span className="text-sm m-auto">
                            {moment(this.state.created_at).format("LLLL")}
                        </span>
                    </td>

                    <td style={{ textAlign: "center"}}>
                        <span className="text-sm">
                            {this.state.user ? (this.state.user.prenom ?? "") + " " + (this.state.user.nom ?? "") : "—"}
                        </span>
                    </td>

                    <td style={{ textAlign: "center"}}>
                        {CORRIGEABLES.includes(this.state.type) && !this.state.corrige && !this.state.correctionDe && (
                            <Button size="sm" color="link" onClick={() => this.onCorriger()}>Corriger</Button>
                        )}
                    </td>
                </tr>
            </>
        );
    }

}));

export default TableMouvRow;
